export const GAS_EKONOM_CODE = '7120';
export const GAS_EKONOMIASSISTENT_CODE = '7121';
export const GAS_CONTROLLER_CODE = '7131';
